import { Box, Paper, Stack, Typography, alpha } from '@mui/material';

export default function ValueCard({ item }) {
  const isRight = item.side === 'right';

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: {
          xs: 'minmax(0, 1fr)',
          lg: 'repeat(2, minmax(0, 1fr))',
        },
        width: '100%',
        minWidth: 0,
        mb: {
          xs: 3,
          md: 5,
        },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          gridColumn: {
            xs: '1',
            md: isRight ? '2' : '1',
          },
          width: {
            xs: '100%',
            md: 'calc(100% - 45px)',
          },
          minWidth: 0,
          justifySelf: {
            xs: 'stretch',
            md: isRight ? 'end' : 'start',
          },
          p: {
            xs: 2,
            sm: 2.5,
            md: 3,
          },
          boxSizing: 'border-box',
          borderRadius: {
            xs: 4,
            md: 5,
          },
          overflow: 'hidden',
          position: 'relative',
          border: `1px solid ${alpha(item.glowColor, 0.25)}`,
          background:
            'linear-gradient(145deg, rgba(255,255,255,.075), rgba(255,255,255,.025))',
          backdropFilter: 'blur(12px)',
          transition: 'transform .3s ease, box-shadow .3s ease',

          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: `0 18px 45px ${alpha(item.glowColor, 0.2)}`,
          },

          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            opacity: 0.08,
            pointerEvents: 'none',
            background: item.gradient,
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="flex-start"
          spacing={{
            xs: 1.5,
            sm: 2,
          }}
          sx={{
            position: 'relative',
            zIndex: 1,
            minWidth: 0,
            gap:1.5
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              width: {
                xs: 40,
                sm: 46,
              },
              height: {
                xs: 40,
                sm: 46,
              },
              flexShrink: 0,
              borderRadius: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: item.gradient,
              color: '#fff',
              boxShadow: `0 8px 25px ${alpha(item.glowColor, 0.35)}`,

              '& svg': {
                fontSize: {
                  xs: 21,
                  sm: 24,
                },
              },
            }}
          >
            {item.icon}
          </Box>

          {/* Content */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <Typography
              sx={{
                color: item.glowColor,
                fontSize: {
                  xs: '0.72rem',
                  sm: '0.78rem',
                },
                fontWeight: 700,
                mb: 0.5,
              }}
            >
              {item.date}
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: '1rem',
                  sm: '1.1rem',
                },
                fontWeight: 800,
                lineHeight: 1.8,
                mb: 1.25,
                overflowWrap: 'anywhere',
              }}
            >
              {item.title}
            </Typography>

            {item.image && (
              <Box
                component="img"
                src={item.image}
                alt={item.title}
                sx={{
                  display: 'block',
                  width: '100%',
                  maxHeight: 280,
                  objectFit: 'cover',
                  borderRadius: 3,
                  mb: 1.5,
                }}
              />
            )}

            <Typography
              sx={{
                color: 'text.secondary',
                fontSize: {
                  xs: '0.75rem',
                  sm: '0.8rem',
                },
                lineHeight: 2,
                whiteSpace: 'pre-line',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
              }}
            >
              {item.desc}
            </Typography>
          </Box>
        </Stack>
      </Paper>

      {/* Timeline point */}
      {/* <Box
        sx={{
          position: 'absolute',
          top: 32,
          right: '50%',
          width: 14,
          height: 14,
          display: {
            xs: 'none',
            md: 'block',
          },
          transform: 'translateX(50%)',
          zIndex: 4,
          borderRadius: '50%',
          background: item.gradient,
          // border: '3px solid #121212',
          boxShadow: `0 0 18px ${alpha(item.glowColor, 0.75)}`,
        }}
      /> */}
    </Box>
  );
}